// extracted by mini-css-extract-plugin
export default {"dccTotals":"nZnuCZI3A3XhaUCSbV9E"};